//React
import React from 'react';
import ReactDOM from 'react-dom';

//Custom
import App from './App';
import * as serviceWorker from './serviceWorker';
//Redux
import { Provider } from 'react-redux'
import store from './store/store'
//Bootstrap
import "./styles/app.scss"
//Needed for the font
import './index.css'

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
